import React, {useEffect, useState, useRef} from 'react';
import './RotationInput.css';
import { useConfig } from './ConfigContext';

const RotationInput = ({angles, setRotationEnabled}) => {
    const [webglUrl, setWebglUrl] = useState("");
    const angleXRef = useRef(null);
    const angleYRef = useRef(null);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setWebglUrl(config["webgl_url"]);
        }
    }, [config]);

    useEffect(() => {

        if(angles === null){
            angles = {};
            angles.x = 0
            angles.y = 0;
        }

        angles.x = Math.round(angles.x * 100) / 100;
        angles.y = Math.round(angles.y * 100) / 100;

        angleXRef.current.value = angles.x;
        angleYRef.current.value = angles.y;

    }, [angles]);

    const handleChange = (e) => {
        const { name, value } = e.target;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        angles.x = angleXRef.current.value;
        angles.y = angleYRef.current.value;
        window.webglIframe.contentWindow.postMessage({type: 'webgl_set_angles', angles: JSON.stringify(angles)}, webglUrl);
        setRotationEnabled(false);
    };

    return (
        <form onSubmit={handleSubmit} className="rotation-input-container">
            <h4 style={{ marginBottom: "15px" }}>Rotation Input</h4>
            <div>
                <label>
                    X:
                    <input
                        type="number"
                        step="0.01"
                        name="angle1"
                        onChange={handleChange}
                        ref={angleXRef}
                    />
                </label>
                <label>
                    Y:
                    <input
                        type="number"
                        step="0.01"
                        name="angle2"
                        onChange={handleChange}
                        ref={angleYRef}
                    />
                </label>
            </div>
            <button type="submit">Apply rotation</button>
        </form>
    );
};

export default RotationInput;
